module.exports = __webpack_public_path__ + "static/img/cimage.e32d8b47.jpg";